import React, { FunctionComponent } from "react"
import { iSpaceQuery } from "../../definitions/Space"
import { iChangeType } from "../../definitions/interfaces"
import FormInput from "../../components/Form/Inputs/FormInput"
import SelectInput from "../../components/Form/Select/Select"

import s from "./Spaces.less"
import { Controller, FormProvider, useForm } from "react-hook-form"

interface iProps {
  setQuery: (data: iSpaceQuery, resetQuery?: boolean) => void
  query: iSpaceQuery
}

const SpaceFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  const methods = useForm({ defaultValues: query })

  return (
    <div className={`filters ${s.filters}`}>
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            placeholder="Title..."
            autoComplete="off"
            name={"title"}
            onChange={onChange}
          />
          <FormInput
            autoComplete="off"
            placeholder="Subtitle..."
            name={"subtitle"}
            onChange={onChange}
          />
          <Controller
            name={"published"}
            control={methods.control}
            render={({ value }) => (
              <SelectInput
                name={"published"}
                onChange={(value) => {
                  onChange({ name: "published", value })
                }}
                isClearable={true}
                value={value}
                options={[
                  { label: "Draft", value: "DRAFT" },
                  { label: "Published", value: "PUBLISHED" },
                ]}
              />
            )}
          />
          <FormInput
            autoComplete="off"
            name="public"
            type="checkbox"
            label="Show Public"
            onChange={onChange}
          />
        </FormProvider>
      </div>
    </div>
  )
}

export default SpaceFilters
